import {
  EDIT_SERIES_INIT,
  EDIT_SERIES_SUCCESS,
  EDIT_SERIES_FAILURE,
  GET_SINGLE_SERIES_SUCCESS,
} from '@store/action-types/series';
import client from '@api-sdk/client';
import moment from 'moment';
import history from '@store/history';
import { toPath, set } from 'lodash';
import { enqueueSnackbar } from '@store/actions/toast';
import translateToastMessage from '@shared/utils/translateToastMessage';
import ROUTES from '@shared/consts/routes';

const editSeriesInit = () => ({ type: EDIT_SERIES_INIT });
const editSeriesSuccess = singleSeries => ({
  type: EDIT_SERIES_SUCCESS,
  payload: { singleSeries },
});
const editSeriesFailure = error => {
  const mappedErrors = error?.errors?.reduce?.((acc, item) => {
    const path = toPath(item.context).filter(
      item => item !== 'children' && item !== 'data' && item !== 'pl' && item !== 'en',
    );

    set(acc, path, item.code.split(':').pop() || item.message);

    return acc;
  }, {});

  return { type: EDIT_SERIES_FAILURE, payload: { error: { ...error, errors: mappedErrors } } };
};

const getSingleSeriesSuccess = singleSeries => ({
  type: GET_SINGLE_SERIES_SUCCESS,
  payload: { singleSeries },
});

const editOffer = ({ seriesData, saveAndBack = false }) => async dispatch => {
  dispatch(editSeriesInit());
  try {
    const editSeriesResponse = await client.editSeries({
      data: {
        limit: seriesData?.limit,
        pricePerShare: seriesData?.pricePerShare,
        bankInfo: {
          accountNumber: seriesData?.bankInfo?.accountNumber,
          bankName: seriesData?.bankInfo?.bankName,
          accountHolder: seriesData?.bankInfo?.accountHolder,
        },
        availableFrom: moment(seriesData?.availableFrom).format('YYYY-MM-DD HH:mm:ss'),
        availableTo: moment(seriesData?.availableTo).format('YYYY-MM-DD HH:mm:ss'),
        name: seriesData?.name,
        displayName: seriesData?.displayName,
        useDefaultPayPalConfig: seriesData?.useDefaultPayPalConfig,
        allowOnlinePayments: seriesData?.allowOnlinePayments,
        payPalCredentials: {
          productionMode: seriesData?.payPalCredentials?.productionMode,
          productionClientId: seriesData?.payPalCredentials?.productionClientId,
          productionClientSecret: seriesData?.payPalCredentials?.productionClientSecret,
          sandboxClientId: seriesData?.payPalCredentials?.sandboxClientId,
          sandboxClientSecret: seriesData?.payPalCredentials?.sandboxClientSecret,
        },
      },
      slug: seriesData?.id,
    });

    await dispatch(editSeriesSuccess(editSeriesResponse));

    if (saveAndBack) {
      history.push(ROUTES.SERIES);
    }

    await dispatch(
      getSingleSeriesSuccess({
        ...editSeriesResponse,
        response: {
          ...editSeriesResponse.response,
          availableTo: editSeriesResponse?.response?.availableTo
            ? moment(editSeriesResponse?.response?.availableTo)
            : moment(),
          availableFrom: editSeriesResponse?.response?.availableFrom
            ? moment(editSeriesResponse?.response?.availableFrom)
            : moment(),
        },
      }),
    );
    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('series.edit'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'success',
        },
      }),
    );
  } catch (error) {
    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('series.error.edit'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'error',
        },
      }),
    );
    dispatch(editSeriesFailure(error));
  }
};

export default editOffer;
